// extracted by mini-css-extract-plugin
export default {"container":"GuidesStats_container__63oVq","item":"GuidesStats_item__hSjud"};